var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2StormDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4 42.5A12.5 12.5 0 0157.06 55h-10v-4h9.84a8.5 8.5 0 100-17H51v-2a13 13 0 10-26 0v2h-5.9a8.5 8.5 0 100 17H27v4h-7.9a12.5 12.5 0 010-25h2a17 17 0 0133.8 0h2a12.5 12.5 0 0112.5 12.5zM45.9 33H37l-7 14.94V48h5.85l-6.18 14.8L46.74 44h-9.62l8.78-11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Storm_day.f5cf6725.svg";
export { SvgB2StormDay as ReactComponent };